import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95ff702a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "olmap-container" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "shade" }, [
  /*#__PURE__*/_createElementVNode("span", null, "按住 Ctrl 并滚动鼠标滚轮才可以缩放地图")
], -1))

import { useStore, } from 'vuex';
import { message, } from 'ant-design-vue';
import {
  computed,
  onMounted,
  reactive,
  watch,
  ref,
  shallowRef,
  onBeforeUnmount,
} from 'vue';

// import Popup from '@/components/popUP/index.vue';

// import OLMap from '@/utils/OLMap';
import VueAMap from '@/utils/AMap';
// import MarkerOverLayer from '@/utils/OLMap/overLayer';
import { AMapLightMap, } from '@/configs';
import { getselecdedAqiImg, } from '@/utils/index';
import CoorsOffset from '@/utils/coordinateConversions';

// const olMapView = ref<any>({});

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


const AMapView = shallowRef<any>({});

const store = useStore();

let locationData = reactive({});

/*
 * 图片四至
 * const extent = [
 *   72,
 *   55,
 *   136,
 *   17,
 * ];
 */

const extent = [[72, 17,], [136, 55,],];
// 地图地理位置初始化
/**
 * 初始化地图
 * @returns {void}
 */
const initViewer = () => {
  const container = document.getElementById('olmap-container') as HTMLElement;

  if (container) {
    // olMapView.value = new OLMap(container, ['vec_w', 'cva_w',]);
    AMapView.value = new VueAMap('olmap-container', [104, 35,], 5, AMapLightMap);
    store.commit('OLMap/setStateItem', {
      value: ['vec_w', 'cva_w',] ,
      type: 'mapType',
    });
    AMapView.value.setStatus({ scrollWheel: false, });
    AMapView.value.setStatus({ rotateEnable: false, });
    const olmapContainer = document.getElementById('olmap-container');

    AMapView.value.on('mousewheel',(e:any) => {
      // e.preventDefault();
      const shade = document.getElementById('shade');
      let time = null;

      if (shade) {
        shade.style.display = 'flex';
        if (time) clearTimeout(time);

        time = setTimeout(() => {
          shade.style.display = 'none';
        }, 1500);
      }
    });
  }
};

/**
 * 定位成功回调
 * @param {any} data 定位成功返回值
 * @returns {void}
 */
const onComplete = (data: any) => {
  const { formattedAddress, position, addressComponent, } = data;

  const transformatLngLat = new CoorsOffset().gcj02towgs84(position?.lng, position?.lat);

  locationData = {
    location: { ...addressComponent, specificLocation: formattedAddress, },
    position: { lng: transformatLngLat[0], lat: transformatLngLat[1], },
  };
  store.commit('OLMap/setStateItem', {
    value: locationData,
    type: 'location',
  });
};

/**
 * 定位失败回调
 * @returns {void}
 */
const onError = (geolo: any) => {
  geolo.getCityInfo((status: string, result: any) => {
    if (status === 'complete') {
      const {
        city, province, position,
      } = result;

      //  formattedAddress, addressComponent,

      const transformatLngLat = new CoorsOffset().gcj02towgs84(position[0], position[1]);

      locationData = {
        location: {
          city, province,
        },
        // ...addressComponent, specificLocation: formattedAddress,
        position: { lng: transformatLngLat[0], lat: transformatLngLat[1], },
      };
      store.commit('OLMap/setStateItem', {
        value: locationData,
        type: 'location',
      });
    } else {
      const city = '南京市';
      const province = '江苏省';
      const location = {
        location: {
          city, province,
        },
        // ...addressComponent, specificLocation: formattedAddress,
        position: { lng: '118.841914179', lat: '31.9295660757', },
      };

      store.commit('OLMap/setStateItem', {
        value: location,
        type: 'location',
      });
    }
  });
};

// 定位失败，设置默认值
const getLocalCityError = () => {
  const city = '南京市';
  const province = '江苏省';
  const location = {
    location: {
      city, province,
    },
    position: { lng: '118.841914179', lat: '31.9295660757', },
  };

  store.commit('OLMap/setStateItem', {
    value: location,
    type: 'location',
  });
};

/**
 * 获取当前地理位置
 * @returns {void}
 */
const getLocation = () => {
  AMap.plugin('AMap.CitySearch', () => {
    const citySearch = new AMap.CitySearch();

    citySearch.getLocalCity((status:any, result:any) => {
      if (status === 'complete' && result.info === 'OK') {
        if (result && result.city && result.bounds) {
          const { city, province, rectangle, } = result;
          const rectangleArray = rectangle.split(';');
          const lng = (Number(rectangleArray[0].split(',')[0]) + Number(rectangleArray[1].split(',')[0])) / 2;
          const lat = (Number(rectangleArray[0].split(',')[1]) + Number(rectangleArray[1].split(',')[1])) / 2;
          const location = {
            location: {
              city, province,
            },
            position: { lng, lat, },
          };

          store.commit('OLMap/setStateItem', {
            value: location,
            type: 'location',
          });
        } else {
          getLocalCityError();
        }
      } else {
        getLocalCityError();
      }
    });
  });
};

// 地图视角
const regionIdExtent = computed(() => store.state.OLMap.regionIdExtent);
let extentFlag = false;

watch([AMapView, regionIdExtent,], ([curOL, curRe,], [oldOL, oldRe,]) => {
  if (
    Object.keys(curOL).length &&
    Object.keys(curRe).length &&
    !extentFlag
  ) {
    const {
      longitudeMin, latitudeMin, longitudeMax, latitudeMax,
    } = curRe;

    extentFlag = true;
    curOL.setExtent(
      [[longitudeMin, latitudeMin + 0.05,], [longitudeMax, latitudeMax - 0.05,],],
      [80, 0,]
    );
  }
});

// 设置掩膜
watch([
  AMapView, regionIdExtent,
], (
  [
    curOlMapView, curRegionIdExtent,
  ]
) => {
  if (
    Object.keys(curOlMapView).length &&
    Object.keys(curRegionIdExtent).length
  ) {
    // curOlMapView.setRegion(curRegionIdExtent.regionName);
  }
});

/*
 * 站点弹框
 * const popupEle = ref<any>(null);
 * const popup = ref<any>({});
 * const popupData = ref<any>({});
 */

// 判断弹框是否关闭
const flagPop = ref<any>(false);
const flag = true;

/*
 * watch([AMapView, popupEle,], ([current, value,], [old, oldValue,]) => {
 *   if (Object.keys(current).length && !Object.keys(old).length && value && flag) {
 *     flag = false;
 *     // popup.value = new MarkerOverLayer(current, value.popupEle, 'id');
 *     popup.value = new PopupWindow(value.popupEle);
 *   }
 *   if (Object.keys(current).length && !oldValue && value && flag) {
 *     flag = false;
 *     // popup.value = new MarkerOverLayer(current, value.popupEle, 'id');
 *     popup.value = new PopupWindow(value.popupEle);
 *   }
 * });
 */

// 绘制站点

//  所选择的产品类型
const selectType = computed(() => store.state.gateway.selectType);
// 站点数据
const airQualityMapData = computed(() => store.state.gateway.airQualityMapData);
// 上一个被点击的站点
const lastMarker = ref<any>(null);

watch(
  [
    AMapView,
    airQualityMapData,
    selectType,
  ],
  ([
    curOlMapView,
    curairQualityMapData,
    curSelectType,
  ]) => {
    if (
      Object.keys(curOlMapView).length &&
      Object.keys(curairQualityMapData).length &&
      curSelectType === '0'
    ) {
      curOlMapView.markEnvironments(curairQualityMapData,(e: any, params: any) => {
        store.dispatch('gateway/getStationData', {
          params,
          callback: (data: any) => {
            // popup.value.setPupPostion(data);

            // 直接传marker的位置marker.getPosition()

            // popup.value.open(AMapView.value, e.target.getPosition());

            // popupData.value = data;
            store.commit('gateway/setStateItem',{ value: data ,type: 'frameData', });
            flagPop.value = true;

            // 将上一个点击的站点变回默认样式
            if (lastMarker.value) {
              // lastMarker.value.setAnchor('center-center');
              lastMarker.value.setOffset(new AMap.Pixel(0, 0));
              lastMarker.value.setStyle({
                width: '0.36rem',
                height: '0.36rem',
                'line-height': '0.33rem',
                background: `url(${getselecdedAqiImg(lastMarker.value.data.aqi === null ?
                  -9999 :
                  Number(lastMarker.value.data.aqi)).replace(/_selected/g, '')}) no-repeat`,
                'background-size': '100% 100%',
              });
            }
            // 将本次点击的图标变成高亮样式 bottom-center失效，不知道为什么

            e.target.setOffset(new AMap.Pixel(6, 0));
            e.target.setStyle({
              width: '0.36rem',
              height: '0.432rem',
              'line-height': '0.312rem',
              background: `url(${getselecdedAqiImg(data.aqi === null ?
                -9999 :
                Number(data.aqi))}) no-repeat`,
              'background-size': '100% 100%',
            });

            lastMarker.value = e.target;
          },
        });
      });

      curOlMapView.setZoom(9);

      /*
       * curOlMapView.markEnvironments(
       *   'environment',
       *   curairQualityMapData,
       *   [0.5, 0.7,],
       *   (value: any, params: any) => {
       *     store.dispatch('gateway/getStationData', {
       *       params,
       *       callback: (data: any) => {
       *         // popup.value.setPupPostion(data);
       */

      /*
       *         // 直接传marker的位置marker.getPosition()
       *         popup.value.open(AMapView.value,postion);
       *         popupData.value = data;
       *         flagPop.value = true;
       *       },
       *     });
       *   }
       * );
       */
      // curOlMapView.getView().setZoom(9);
    }
  }
);

// AQI产品数据
const productDatas = computed(() => store.state.gateway.productDatas);

watch(
  [
    AMapView,
    productDatas,
    selectType,
  ],([
    curOlMapView,
    curproductDatas,
    curSelectType,
  ]) => {
    if (Object.keys(curOlMapView).length && Object.keys(curproductDatas).length &&
   curSelectType === '0') {
    // 卫星/站点产品要素
      const path = curproductDatas[Object.keys(curproductDatas)[Object.keys(curproductDatas).length - 1]]?.filePath;

      if (path) {
        curOlMapView.addPicture(
          path,
          extent
        );
      }
    } else if (Object.keys(curOlMapView.pictureLayer).length) {
      curOlMapView.pictureLayer.hide();
    }
  }
);

// 添加反演图

// PM产品数据
const pmDatas = computed(() => store.state.gateway.pmDatas);

watch([
  AMapView,
  pmDatas,
  selectType,
], (
  [
    curOlMapView,
    curPmDatas,
    curSelectType,
  ]
) => {
  if (
    Object.keys(curOlMapView).length &&
    Object.keys(curPmDatas).length &&
   curSelectType === '1'
  ) {
    curOlMapView.addPicture(
      curPmDatas?.airIssuePathDTOS?.[0]?.filePath,
      extent
    );
    // curOlMapView.getView().setZoom(12);

    // curOlMapView.setZoom(12);
  } else if (Object.keys(curOlMapView.pictureLayer).length) {
    curOlMapView.pictureLayer.hide();
  }
});

// 添加影像图

// 实时影像数据
const realtimeDatas = computed(() => store.state.gateway.realtimeDatas);

watch([
  AMapView,
  realtimeDatas,
  selectType,
], (
  [
    curOlMapView,
    curRealtimeDatas,
    curSelectType,
  ]
) => {
  if (
    Object.keys(curOlMapView).length &&
    Object.keys(curRealtimeDatas).length &&
    curSelectType === '2'
    ) {
    curOlMapView.addPicture(
      `/AirImage${curRealtimeDatas?.airIssuePathDTOS?.[0]?.relativePath}`,
      extent
    );
  } else if (Object.keys(curOlMapView.pictureLayer).length) {
    curOlMapView.pictureLayer.hide();
  }
});

// 添加夜间灯光图

// 夜间灯光数据
const eveLightDatas = computed(() => store.state.gateway.eveLightDatas);

watch([
  AMapView,
  eveLightDatas,
  selectType,
], (
  [
    curOlMapView,
    curEveLightDatas,
    curSelectType,
  ]
) => {
  if (
    Object.keys(curOlMapView).length &&
    Object.keys(curEveLightDatas).length &&
   curSelectType === '3'
  ) {
    curOlMapView.addPicture(
      curEveLightDatas?.airIssuePathDTOS?.[0]?.filePath,
      extent
    );
    // curOlMapView.getView().setZoom(12);

    // curOlMapView.setZoom(12);
  } else if (Object.keys(curOlMapView.pictureLayer).length) {
    curOlMapView.pictureLayer.hide();
  }
});

// 根据选择按钮清理图层
watch([
  AMapView, selectType,
], ([
  curOlMapView, curSelectType,
]) => {
  // 清除图片图层
  if (
    curSelectType === '0' &&
    Object.keys(curOlMapView.pictureLayer).length
  ) {
    // curOlMapView.customRemoveLayer('pictureLayer');
    curOlMapView.removePicture();
  }
  // 清除站点
  if (
    curSelectType !== '0' &&
    Object.keys(curOlMapView.enviromentStationLayer).length
  ) {
    // curOlMapView.customRemoveLayer('enviromentStationLayer');
    curOlMapView.removeMarkEnvironments();
  }
  // 清除弹框
  if (curSelectType !== '0') {
    // popup.value.setPupPostion();
    AMapView.value.clearInfoWindow();
    flagPop.value = false;
  }
});

// 监听弹框是否关闭
watch(
  [
    flagPop,
    AMapView,
    airQualityMapData,
  ],
  ([
    curFlagPop,
    curOlMapView,
    curairQualityMapData,
  ]) => {
    if (
      !curFlagPop &&
       Object.keys(curOlMapView.enviromentStationLayer).length &&
       Object.keys(curairQualityMapData).length
    ) {
      // curOlMapView.enviromentStationLayer.closeInfoWIn();
      AMapView.value.clearInfoWindow();
    }
  }
);

onMounted(() => {
  const dom = document.querySelector('.close-dom') as HTMLElement;

  getLocation();
  initViewer();

  if (dom) {
    dom.onclick = () => {
      // popup.value.setPupPostion();
      AMapView.value.clearInfoWindow();
      flagPop.value = false;
    };
  }

  document.onkeydown = (e) => {
    // e.preventDefault();
    const shade = document.getElementById('shade');

    if (e.key === 'Control') {
      AMapView.value.setStatus({ scrollWheel: true, });

      AMapView.value.on('mousewheel', () => {
        if (shade) {
          shade.style.display = 'none';
        }
      });
    }
  };

  document.onkeyup = () => {
    AMapView.value.setStatus({ scrollWheel: false, });
    AMapView.value.on('mousewheel', () => {
      const shade = document.getElementById('shade');
      let time = null;

      if (shade) {
        shade.style.display = 'flex';
        if (time) clearTimeout(time);
        time = setTimeout(() => {
          shade.style.display = 'none';
        }, 600);
      }
    });
  };
});

onBeforeUnmount(() => {
  extentFlag = false;
  // olMapView.value.dispose();

  AMapView.value.destroy();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2
  ], 64))
}
}

})